"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var typings_1 = require("../typings");
function getComponentFromRoot(element) {
    return element._reactRootContainer &&
        element._reactRootContainer._internalRoot.current ||
        undefined;
}
function getComponentFromNode(element) {
    var getReact = function (element) {
        var reactKey = Object.keys(element)
            .reduce(function (res, key) { return res || key.indexOf('__reactInternalInstance$') === 0 && key; }, false);
        return reactKey ?
            element[reactKey] :
            undefined;
    };
    var thisInstance = getReact(element);
    if (!thisInstance && element.firstElementChild) {
        var childInstance = getReact(element.firstElementChild);
        while (childInstance) {
            if (childInstance.tag === typings_1.WorkTag.portalHost && childInstance.stateNode.containerInfo === element) {
                thisInstance = childInstance;
                break;
            }
            childInstance = childInstance.return || undefined;
        }
    }
    return thisInstance;
}
function isClickableComponents(component) {
    return component.tag === typings_1.WorkTag.host && (Boolean(component.pendingProps && component.pendingProps.onClick) ||
        component.type === 'a' || component.type === 'button');
}
exports.isClickableComponents = isClickableComponents;
function isReactInternalFiber(value) {
    return Boolean(value && 'pendingProps' in value && 'sibling' in value && 'child' in value &&
        'return' in value && 'tag' in value && 'type' in value && 'stateNode' in value);
}
exports.isReactInternalFiber = isReactInternalFiber;
function getBaobabNodeFromUseBaobab(value) {
    var _a, _b, _c;
    var deps = (_c = (_b = (_a = value) === null || _a === void 0 ? void 0 : _a.updateQueue) === null || _b === void 0 ? void 0 : _b.lastEffect) === null || _c === void 0 ? void 0 : _c.deps;
    if (!Array.isArray(deps))
        return;
    for (var i = 0; i < deps.length; i++) {
        var dep = deps[i];
        if (dep && dep.__useBaobab) {
            return dep;
        }
    }
    return undefined;
}
exports.getBaobabNodeFromUseBaobab = getBaobabNodeFromUseBaobab;
function isReactBaobabNode(value) {
    return Boolean(value &&
        (value.tag === typings_1.WorkTag.function || value.tag === typings_1.WorkTag.class) &&
        (('isBaobabNode' in value.type && value.type.isBaobabNode) ||
            getBaobabNodeFromUseBaobab(value)));
}
exports.isReactBaobabNode = isReactBaobabNode;
function getNodeFromThis(component) {
    if (isReactBaobabNode(component)) {
        if (component.stateNode) {
            return component.stateNode.node;
        }
        return getBaobabNodeFromUseBaobab(component);
    }
    return undefined;
}
exports.getNodeFromThis = getNodeFromThis;
function getComponent(value) {
    if (!value)
        return undefined;
    if (isReactInternalFiber(value))
        return value;
    return getComponentFromRoot(value) || getComponentFromNode(value);
}
exports.getComponent = getComponent;
function getBaobabComponent(value) {
    if (!value)
        return undefined;
    var component = getComponent(value);
    while (component) {
        if (isReactBaobabNode(component))
            return component;
        component = component.return || undefined;
    }
    return undefined;
}
exports.getBaobabComponent = getBaobabComponent;
function getNode(value) {
    if (!value)
        return undefined;
    var component = getBaobabComponent(value);
    return component ? getNodeFromThis(component) : undefined;
}
exports.getNode = getNode;
function findById(tree, id) {
    if (tree.baobab && tree.baobab.id === id)
        return tree;
    return tree.children &&
        tree.children.reduce(function (result, node) { return result || findById(node, id); }, undefined);
}
exports.findById = findById;
function createTree(tree, node) {
    var result = [];
    var component = node ? getComponent(tree) : getBaobabComponent(tree);
    while (component) {
        var child = component.child;
        var baobab = getNodeFromThis(component);
        if (baobab) {
            var newNode = {
                path: (node && node.path ? node.path + '.' : '') + baobab.name,
                baobab: baobab,
            };
            var children = child ? createTree(child, newNode) : [];
            if (children.length > 0)
                newNode.children = children;
            result = result.concat(newNode);
        }
        else {
            var isClickable = isClickableComponents(component);
            if (component.tag === typings_1.WorkTag.host && node && !node.container) {
                node.container = component.stateNode;
            }
            if (isClickable) {
                var element = component.stateNode;
                if (!node) {
                    node = {
                        path: '',
                        baobab: undefined,
                    };
                }
                if (node.baobab && !node.clickElement && !node.errorElements) {
                    node.clickElement = element;
                }
                else {
                    if (!node.errorElements) {
                        node.errorElements = node.clickElement ? [node.clickElement] : [];
                        delete node.clickElement;
                    }
                    node.errorElements.push(element);
                }
            }
            if (child) {
                result = result.concat(createTree(child, node));
            }
        }
        component = component.sibling || undefined;
    }
    return result;
}
exports.createTree = createTree;
function getAllTrees(rootSelector) {
    var roots = document.querySelectorAll(rootSelector);
    return __spread(roots).reduce(function (res, item) { return item ? res.concat(createTree(item)) : res; }, []);
}
exports.getAllTrees = getAllTrees;
function filterErrors(node) {
    var errorNodes = node.errorElements ? [node] : [];
    return node.children ?
        node.children.reduce(function (res, child) { return res.concat(filterErrors(child)); }, errorNodes) :
        errorNodes;
}
exports.filterErrors = filterErrors;
